import React from 'react';

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-logo">
        <img
          src="/images/logo/LOGO2_TYPE_HORIZ_WHW_sm-300dpi.rgb.jpg"
          alt="Windy Hill Weavers - Handwoven Rugs & Home Decor"
        />
      </div>
      <div className="hero-editorial">
        <p>
          Windy Hill Weavers blends artistry with sustainability to create a distinctive
          collection of handwoven area rugs and other home d&eacute;cor items. I weave colorful,
          reversible rugs from recycled Pendleton<sup>&copy;</sup> wool in an array of beautiful styles
          that enhance any home. I also create upcycled denim jackets, pillows, wine and
          flower totes, and other items from Pendleton<sup>&copy;</sup> fabric.
        </p>
      </div>
      <div className="hero-categories">
        <a href="#gallery-rugs" className="hero-category-card">
          <h3>Handwoven Rugs</h3>
          <div className="hero-category-img">
            <img src="/images/gallery/KathyMarty_ColumbiaRiver_300dpi_small.jpg" alt="Handwoven Rugs" />
          </div>
        </a>
        <a href="#gallery-decor" className="hero-category-card">
          <h3>Home D&eacute;cor</h3>
          <div className="hero-category-img">
            <img src="/images/gallery/decor/Pillows_1059x1400.jpg" alt="Home Decor" />
          </div>
        </a>
        <a href="#gallery-jackets" className="hero-category-card">
          <h3>Upcycled Jackets</h3>
          <div className="hero-category-img">
            <img src="/images/gallery/jackets/KathyMarty_jacket.jpg" alt="Upcycled Jackets" />
          </div>
        </a>
      </div>
    </section>
  );
}

export default Hero;
